import { LoadingStatus, EpiPage } from '@api/types';
import {
  AdditionalPageContent,
  DataLoadingProgress,
  EditableContentArea,
  StyledContentArea,
} from '@components';
import { Stack } from '@mui/material';

// TYPES
//------
export interface MainContentProps {
  page?: EpiPage;
  status?: LoadingStatus;
  children?: React.ReactNode;
}

// COMPONENTS
//------------
export const MainContentArea = ({ page = {}, status = {}, children }: MainContentProps) => {
  const { isLoading, isFetching } = status;
  const isWorking = isLoading || isFetching;
  return (
    <StyledContentArea component='main' className='main-content-area'>
      {!isWorking && (
        <EditableContentArea property='Content'>
          <AdditionalPageContent page={page} />
        </EditableContentArea>
      )}
      {isWorking && (
        <Stack className='fade-in-transition'>
          <DataLoadingProgress />
        </Stack>
      )}
      {children}
    </StyledContentArea>
  );
};
